import { motion } from "framer-motion"
import styled from "styled-components"

import useContent from "../hooks/useContent"
import ButtonIcon from "./ButtonIcon"

const Container = styled(motion.div)`
  position: fixed;
  top: 12px;
  width: calc(100% - 24px);
  margin: 0px 12px;
  padding: 8px;
  box-sizing: border-box;
  background: #363636;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
`

const Text = styled(motion.p)`
  color: white;
  text-align: center;
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 600;
  width: 100%;
  padding: 0px 8px 32px;
`

const animations = {
  variants: {
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        opacity: {
          duration: 0.5,
          delay: 1,
        },
        y: {
          duration: 1,
          delay: 0.5,
        },
      },
    },
    hidden: {
      opacity: 0,
      y: -100,
      transition: {
        opacity: {
          duration: 0.5,
        },
        y: {
          duration: 1,
        },
      },
    },
  },
  initial: "hidden",
  animate: "visible",
  exit: "hidden",
}

const Hint = ({ onClose }) => {
  const hintText = useContent({ path: "hint" })

  return (
    <Container {...animations}>
      <ButtonIcon iconName={"IconClose"} onClick={onClose} />
      <Text>{hintText}</Text>
    </Container>
  )
}
export default Hint
